import * as React from 'react';
import ImgYear15 from "../../components/defaults/studioImg/imgYear15"
import ImgYear16 from "../../components/defaults/studioImg/imgYear16"
import ImgYear17 from "../../components/defaults/studioImg/imgYear17"
import ImgYear18 from "../../components/defaults/studioImg/imgYear18"
import ImgYear19 from "../../components/defaults/studioImg/imgYear19"
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactPlayer from 'react-player'
import navigateTo from '../defaults/NavigateTo';
import Animated from "../animated"


const Year = ({ year, imageData }) =>
{
    const [scroll, setScroll] = React.useState(false);
    const [show, setShow] = React.useState(false)
    const [images, setImages] = React.useState([]);
    const [count, setCount] = React.useState(20);

    const component = {
        15: ImgYear15,
        16: ImgYear16,
        17: ImgYear17,
        18: ImgYear18,
        19: ImgYear19,
    }

    const CurrentYear = component[year];

    function onScroll()
    {
        let isScroll = window.scrollY >= 450;
        if (isScroll !== scroll)
        {
            setScroll(isScroll)
        }
    }


    React.useEffect(() =>
    {
        let timeout;
        if (!scroll)
        {
            if (timeout)
            {
                clearTimeout(timeout)
            }
            timeout = setTimeout(() =>
            {
                setShow(false)
            }, 700);

        }
        else { setShow(true) }
        window.addEventListener("scroll", onScroll)
        if (count === 20)
        {
            setImages(imageData.slice(0, count))
        }
        else
        {
            setTimeout(() =>
            {
                setImages(imageData.slice(0, count))
            }, 1500);
        }
        return () =>
        {
            window.removeEventListener("scroll", onScroll);
            clearTimeout(timeout)
        }
    }, [count, scroll])



    function fetchMore()
    {
        if (count + 12 > imageData.length)
        {
            let finalCount = imageData.length - count;
            setCount(count + finalCount)
        }
        else
        {
            setCount(count + 12);
        }
    }

    return (
        <>
            <InfiniteScroll
                className="year-album"
                dataLength={images.length}
                next={fetchMore}

                hasMore={count < imageData.length}
                loader={count <= imageData.length && count !== 0 && <div className="loader" key={0}>
                    <div className="lds-dual-ring" />
                </div>
                }>
                {
                    images.map((item, index) => <div key={index} className="year-images" style={{ width: item.width }}>
                        {
                            // item.type === "video" ? <ReactPlayer
                            //     height="100%"
                            //     width="100%"
                            //     playing={true}
                            //     loop={true}
                            //     muted={true}
                            //     controls={true}
                            //     url={item.url}
                            // /> :

                        }
                        <CurrentYear image={item.name} />
                    </div>)
                }
            </InfiniteScroll>
            {show && <Animated from={{ opacity: 0 }} to={{ opacity: 1 }} inverse={!scroll}>
                {
                    style => <div style={style} className="toTop">
                        <a title="Top" href="#studio" onClick={navigateTo}>
                            <img src={`${require("../../images/arrow-top.png")}`} alt="" />
                        </a>
                    </div>
                }
            </Animated>}

        </>
    );
}

export default Year;